import { apis } from './api';

/**
 * Cálculo unificado de tarifa estimada vía API (fuente de verdad en backend).
 */
export function estimateTripTariff (payload) {
    return apis.companyApi.estimateTariff(payload);
}



// WEBPACK FOOTER //
// ./src/services/tripTariff.js